import "./doctor.css"
import Team from "../team/team"
function Doctor (){
    return(
        <>
        <div className="doctors">
          <div className="continer">
  <h3>Our Distinguished Doctors</h3>
  <p>
    We take pride in presenting a select group of specialized doctors and experts across diverse medical fields. 
    Our medical team is committed to delivering the highest standards of healthcare, with a focus on patient comfort 
    and meeting individual needs. With years of experience and dedication, our doctors ensure exceptional and 
    personalized medical services for every patient.
  </p>
</div>
<div className="content">
    <Team/>
</div>
        </div>
        </>
    )
}
export default Doctor